<template>
    <div
        v-if="chips.length"
        class="filter-chips"
    >
        <div
            v-for="chip in chips"
            :key="chip.label"
            class="chip"
        >
            <div class="label">{{ chip.label }}</div>

            <ThLink
                v-if="'getRouteRemove' in chip"
                :to="chip.getRouteRemove()"
                :aria-label="`Remove ${chip.label} filter`"
                class="remove"
            >
                <Icon icon="close-bold" />
            </ThLink>

            <div
                v-else
                class="remove"
                @click="chip.onRemove"
            >
                <Icon icon="close-bold" />
            </div>
        </div>

        <ThLink
            v-if="chips.length"
            v-qa="'filters-clear-all'"
            :to="routeReset"
            class="reset"
        >
            Clear
        </ThLink>
    </div>
</template>

<script lang="ts" setup>
import type { ButtonRouteRelative } from '../buttons/useThButton'

import ThLink from '../buttons/ThLink.vue'
import Icon from '../icon/Icon.vue'

export type FilterChip = {
    label: string
} & (FilterChipRemoveRoute | FilterChipRemoveFunction)

type FilterChipRemoveRoute = {
    getRouteRemove: () => ButtonRouteRelative
}

type FilterChipRemoveFunction = {
    onRemove: () => void
}

defineProps<{
    chips: FilterChip[]
    routeReset: ButtonRouteRelative
}>()
</script>

<style lang="scss" scoped>
.filter-chips {
    display: flex;
    flex-wrap: wrap;

    margin: 0 auto 10px;
    width: 100%;
    max-width: 100%;

    font-family: $effra-font-stack;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0.05em;
    text-transform: uppercase;

    .chip,
    .reset {
        margin: 0 10px 10px 0;
        display: flex;
        align-items: center;
    }

    .reset {
        padding-top: 2px;
    }

    .chip {
        border: 1px solid $grey-400;
        border-radius: 199px;

        .label {
            padding: 5px 10px;
            line-height: 15px;
        }

        .remove {
            font-size: 14px;
            padding: 0 8px 0 5px;
            height: 30px;
            line-height: 30px;
            cursor: pointer;
            opacity: 0.5;

            @include hover() {
                opacity: 1;
            }
        }
    }
}
</style>
